import { render, staticRenderFns } from "./ModalCodigosClinicos.vue?vue&type=template&id=91588c02&scoped=true"
import script from "./ModalCodigosClinicos.vue?vue&type=script&lang=js"
export * from "./ModalCodigosClinicos.vue?vue&type=script&lang=js"
import style0 from "./ModalCodigosClinicos.vue?vue&type=style&index=0&id=91588c02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91588c02",
  null
  
)

export default component.exports